import { Card, Col, Form, Row } from "antd";
import React from "react";

function History() {
  return (
    <div className="history">
      <Card title="History">
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 8 }}
          labelWrap={{ span: 8 }}
        >
          <Row>
            <Col span={24}>
              <Form.Item label="Created By">
                <p>
                  <span className="onclick-text">aamir ali</span> on 02/22/2023
                  06:37 AM
                </p>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Last Saved By">
                <p>
                  <span className="onclick-text">aamir ali</span> on 02/22/2023
                  06:37 AM
                </p>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}

export default History;
